module.exports = __webpack_public_path__ + "img/video-play-icon.e8ac9060.png";